(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Custom-slideshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    const section = document.querySelector('[data-slideshow]');
    if (!section) return;

    const slides = section.querySelectorAll('[data-slide]');
    const dots = section.querySelectorAll('[data-dot]');
    let index = 0;

    const show = (i) => {
      slides.forEach(s => s.classList.remove('is-active'));
      dots.forEach(d => d.classList.remove('is-active'));
      slides[i].classList.add('is-active');
      dots[i].classList.add('is-active');
      index = i;
    };

    section.querySelector('[data-next]')?.addEventListener('click', () => show((index + 1) % slides.length));
    section.querySelector('[data-prev]')?.addEventListener('click', () => show((index - 1 + slides.length) % slides.length));
    dots.forEach(d => d.addEventListener('click', () => show(+d.dataset.dot)));
  };

  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (section) => {
    const slides = section.querySelectorAll('[data-slide]');
    const dots = section.querySelectorAll('[data-dot]');
    const next = section.querySelector('[data-next]');
    const prev = section.querySelector('[data-prev]');
    let index = 0;
    let timer;

    const show = (i) => {
      slides.forEach(s => {
        s.classList.remove('is-active');
        s.querySelectorAll('video').forEach(v => v.pause());
      });
      dots.forEach(d => d.classList.remove('is-active'));

      slides[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');

      const v = slides[i].querySelector('video');
      if (v) v.play();

      index = i;
    };

    const start = () => {
      timer = setInterval(() => show((index + 1) % slides.length), 5000);
    };

    const reset = () => {
      clearInterval(timer);
      start();
    };

    next && (next.onclick = () => { show((index + 1) % slides.length); reset(); });
    prev && (prev.onclick = () => { show((index - 1 + slides.length) % slides.length); reset(); });
    dots.forEach(d => d.onclick = () => { show(+d.dataset.dot); reset(); });

    start();
  };

  document.querySelectorAll('[data-slideshow]').forEach(init);
  document.addEventListener('shopify:section:load', e => {
    const s = e.target.querySelector('[data-slideshow]');
    s && init(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
